import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
//https://www.wenjiangs.com/doc/n7buhgkpyd  中文文档(参考)
import confirm from '@cmp/confirm'
import notify from '@cmp/notify'
import request from '@/utils/request'

import '@assets/css/theme.scss';
import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);
Vue.config.productionTip = false

Vue.prototype.$confirm = confirm
Vue.prototype.$notify = notify

// Vue.use(test)  // 方法1.仅在组件里使用
// Vue.prototype.$test = test  // 方法2.组件和组件以外的情况下使用


//中英文切换
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n=new VueI18n({
    locale:localStorage.getItem('languageSet')||'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
    messages:{
        'zh':require('./i18n/zh'),
        'en':require('./i18n/en')
    }
});
(function(window){
  window.onresize=function(){
      rem();
  }
  function rem(){
      document.documentElement.style.fontSize = document.documentElement.clientWidth /100 + "px";
  }
  rem();
})(window);


Vue.prototype.$http = request
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
